import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import { 
  renderMultiLineTextField,
  renderSelectField6,
} from '../../../form-global-components/components-form-components-for-react-final-form';
class BOPModuleGangAffiliation extends Component {
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    component={renderSelectField6}
                    locked={this.props.locked}
                    id='bopgangaffiliation' 
                    name='bopgangaffiliation'
                    label="Gang Affiliation"
                    footerMessage=''
                    autoFocus
                    dataArray={
                      this.props.gangaffiliationsList.map(gangaffiliation => ({
                        value: gangaffiliation.id,
                        label: gangaffiliation.description
                      }))
                    }
                  />
                                                                        {/* 
                                                                                          >
                                                                                            <option value='0' >none</option>
                                                                                            {this.props.gangaffiliationsList.map((gangaffiliation, index) => {
                                                                                              return (
                                                                                                <option key={gangaffiliation.id} value={gangaffiliation.id} >{gangaffiliation.description}</option>
                                                                                              )
                                                                                            }) }
                                                                                          </Field> 
                                                                        */}
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                  <Field
                    component={renderMultiLineTextField}
                    locked={this.props.locked}
                    id='bopgangaffiliationcomments'
                    name='bopgangaffiliationcomments'
                    label="Gang Affiliation Comments"
                    rows='6'
                    emptyText='Your comments should be clear and concise.'
                    footerMessage='Your comments should be clear and concise.'
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
BOPModuleGangAffiliation.propTypes = {
  locked: PropTypes.bool,
  gangaffiliationsList: PropTypes.array,
}
export default BOPModuleGangAffiliation;